import {
  ShopErrorContent,
  ShopFilterType,
  ShopSortOption,
  ShopSortType,
} from '../state/types';
import { IconName } from '@betty/moonlight/lib/common/Icon/Icon.types';
import { ShopErrorCode } from '../state/types';
import { PurchasedItemRewardType } from '../state/items/items.types';

export const shopFilterIconMap: Partial<Record<ShopFilterType, IconName>> = {
  BestValue: 'percent',
  CashReward: 'bettyDollar',
  FreeSpins: 'freeSpins',
  Purchased: 'shoppingBag',
};

export const shopSaleFilterIcon: IconName = 'flame';

export const shopErrorContentMap: Partial<
  Record<ShopErrorCode, ShopErrorContent>
> = {
  [ShopErrorCode.InsufficientBalance]: {
    locNS: 'shop',
    locKey: 'shopErrorInsufficientBalance',
  },
  [ShopErrorCode.ItemNotFound]: {
    locNS: 'shop',
    locKey: 'shopErrorItemNotFound',
  },
  [ShopErrorCode.ItemUnderMaintenance]: {
    locNS: 'shop',
    locKey: 'shopErrorItemUnderMaintanence',
  },
};

export const defaultShopError: ShopErrorContent = {
  locNS: 'shop',
  locKey: 'shopErrorGeneric',
};

export const shopSortOptions: ShopSortOption[] = [
  {
    locNS: 'shop',
    locKey: 'shopSortRelevance',
    value: 'Relevance',
  },
  {
    locNS: 'shop',
    locKey: 'shopSortLowToHigh',
    value: 'LowToHigh',
  },
  {
    locNS: 'shop',
    locKey: 'shopSortHighToLow',
    value: 'HighToLow',
  },
];

export const defaultShopSortOption: ShopSortType = 'Relevance';

export const staticShopFilters: Array<ShopFilterType> = [
  'BestValue',
  'CashReward',
  'FreeSpins',
  'Purchased',
];

export const shopItemRewardTypeMap: Record<PurchasedItemRewardType, string> = {
  CoinsReward: 'Coins',
  CashReward: 'Cash',
  FreeSpins: 'FreeSpins',
};
